import { useDispatch } from "react-redux";

import { useQuery } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { ApiResponse } from "types/api";

import { Filter } from "./types";

export const useProvidersFilters = () => {
  const dispatch = useDispatch();

  return useQuery<ApiResponse<Filter[]>>({
    queryKey: ["providersFilters"],
    queryFn: async () =>
      dispatch(
        apiThatThrows.getTiVoProvidersFilters.action({
          cache: true,
        })
      ),
  });
};
